import { z } from 'zod'

export const badgeIdSchema = z.enum([
  'first_plan',
  'road_warrior',
  'explorer',
  'socialite',
  'completionist'
])

export const claimBadgeSchema = z.object({
  badgeId: badgeIdSchema
})

export const leaderboardQuerySchema = z.object({
  region: z.string().optional(),
  period: z.enum(['day', 'week', 'month', 'all']).default('week')
})
